export default function Machines_B_3 (number = 1) {
  return {
    name: '四向分流器',
    icon: '/static/img/machines/b3.png',
    number
  }
}



// WEBPACK FOOTER //
// ./src/components/Machines_B/Machines_B_3.js